/* src/app/pages/examples/profilepage/components/tabela-conhecimentos/tabela-conhecimentos.component.scss */
.table {
  background-color: transparent !important;
}
/*# sourceMappingURL=tabela-conhecimentos.component.css.map */
